import {
  GoogleMap,
  Marker,
  StreetViewPanorama,
  useJsApiLoader,
} from "@react-google-maps/api";
import { useEffect, useState } from "react";
import { useGetAdvertDetails } from "../ServerSideStates";
import { useSearchParams } from "react-router-dom";
import SLogo from "../../../../assets/Images/Header/YellowSLogo.svg"

const containerStyle = {
  width: "100%",
  height: "400px",
};

const initialCenter = {
  lat: 38.426469, // Kayseri coordinates
  lng: 27.133802,
};

const CustomMap = () => {
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API || "",
    libraries: ["places"],
  });

  const [marker, setMarker] = useState<google.maps.LatLngLiteral | null>({
    lat: 38.426469,
    lng: 27.133802,
  });
  const [center, setCenter] = useState(initialCenter); // Center state
  const [searchParams] = useSearchParams();
  const advertId = searchParams.get("id");
  const advertDetails = useGetAdvertDetails(advertId);

  useEffect(() => {
    if (advertDetails.data?.data) {
      const detailsData = advertDetails.data.data;
      if (detailsData?.latitude && detailsData?.longitude) {
        const newMarker = {
          lat: Number(detailsData.latitude),
          lng: Number(detailsData.longitude),
        };
        setMarker(newMarker);
        setCenter(newMarker); 
      }
    }
  }, [advertDetails.data]);
console.log(marker)
  return (
    <>
      {isLoaded ? (
        <>
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={14}
          >
            {marker && (
              <Marker
              position={marker}
              icon={{
                url: SLogo, 
                scaledSize: new google.maps.Size(30, 30), 
                anchor: new google.maps.Point(15, 15), 
              }}
              />
            )}

            <StreetViewPanorama
              options={{
                position: marker || initialCenter,
                pov: {
                  heading: 100,
                  pitch: 0,
                },
                zoom: 1,
              }}
            />
          </GoogleMap>
        </>
      ) : (
        <p>Harita yukleniyor</p>
      )}
    </>
  );
};

export default CustomMap;
